/** .empty — "nothing here", not "something went wrong". */
export default function EmptyState({ children = 'Nothing to show yet.' }) {
  return <div className="empty">{children}</div>;
}
